import { ProfileExport } from "PFTypes";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { getTranslationKey } from "../../../../../helpers/custom_pptx_template";
import { CustomType } from "../../../../types";
import { filterDeselectedSkills } from "../../helpers";
import { Field } from "./field";

type SkillsProps = {
  skillsType: CustomType;
  profile: ProfileExport;
  templateKey: string;
};

export const Skills = ({ skillsType, profile, templateKey }: SkillsProps) => {
  const { t } = useTranslation("profiles", { keyPrefix: "export" });
  const translationKey = getTranslationKey(templateKey);

  const [coreSkills, otherSkills] = useMemo(() => {
    const sortAndFilterSkills = (skills) =>
      filterDeselectedSkills(skills, skillsType)
        .slice(0, 9)
        .map(({ text }) => text)
        .sort((t1, t2) => t1.toLowerCase().localeCompare(t2.toLowerCase()));
    const coreSkills = sortAndFilterSkills(profile.skills?.filter(({ top }) => top) || []);
    const otherSkills = sortAndFilterSkills(profile.skills?.filter(({ top }) => !top) || []);

    return [coreSkills, otherSkills];
  }, [profile, skillsType.text]);

  return (
    <>
      {coreSkills.length > 0 && (
        <Field title={t(`${translationKey}.coreSkills`)}>
          <ul>
            {coreSkills.map((item) => (
              <li key={item}>
                <div>{item}</div>
              </li>
            ))}
          </ul>
        </Field>
      )}
      {otherSkills.length > 0 && (
        <Field title={t(`${translationKey}.otherSkills`)}>
          <ul>
            {otherSkills.map((item) => (
              <li key={item}>
                <div>{item}</div>
              </li>
            ))}
          </ul>
        </Field>
      )}
    </>
  );
};
